import React from "react";

const Business = ({ ui }) => {
  return (
    <div id="business" className="text-center business-section">
      <div className="container">
        <div className="section-title">
          <h2>{ui?.title}</h2>
        </div>

        <div className="row">
          <div className="col-md-6 business-text-column">
            <div className="integration-text">
              <h3 className="business-headline">{ui?.headline}</h3>
              <p className="business-copy">{ui?.copy}</p>
              <a
                href="#contact"
                className="btn btn-custom btn-lg page-scroll"
              >
                {ui?.cta}
              </a>
            </div>
          </div>
          <div className="col-md-6 business-image-wrap">
            <img
              src="/img/EHR-data-integration.png"
              alt={ui?.imageAlt}
              className="business-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Business;
